import React from "react"
import { Create } from "react-admin"
import { usePermissions } from "ra-core"
import { NewActionsTabs } from "components/ui/layouts"
import Form from "./form"


function ObjectCreate(props: React.PropsWithChildren): JSX.Element  {
    const { permissions } = usePermissions()

    return (
        <Create redirect="show" actions={<NewActionsTabs />}>
            <Form newRecord />
        </Create>
    )
}

export default ObjectCreate